import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import bnrImg1 from "../../images/banner/img1.jpg";
import waveBlue from "../../images/shap/wave-blue.png";
import circleDots from "../../images/shap/circle-dots.png";
import plusBlue from "../../images/shap/plus-blue.png";



// Si no tienes bootstrap instalado, puedes añadir el CDN en tu index.html:
// <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">

const Operaciones = () => {
  const [display, setDisplay] = useState("0");
  const [formula, setFormula] = useState("");
  const [isFinished, setIsFinished] = useState(false);

  const handleClick = (value) => {
    if (isFinished && !isNaN(value)) {
      setDisplay(value);
      setFormula(value);
      setIsFinished(false);
      return;
    }
    
    setIsFinished(false);

    if (value === "AC") {
      setDisplay("0");
      setFormula("");
    } else if (value === "=") {
      try {
        // Validación básica para evitar errores de sintaxis
        const result = eval(formula.replace(/x/g, "*"));
        setDisplay(String(result));
        setFormula(String(result));
        setIsFinished(true);
      } catch (e) {
        setDisplay("Error");
        setFormula("");
      }
    } else {
      // Evitar ceros a la izquierda y concatenar
      const newFormula = formula === "0" ? value : formula + value;
      setFormula(newFormula);
      setDisplay(newFormula);
    }
  };

  const botones = [
    { txt: "AC", cls: "btn-danger" }, { txt: "(", cls: "btn-secondary" }, { txt: ")", cls: "btn-secondary" }, { txt: "/", cls: "btn-warning" },
    { txt: "7", cls: "btn-info" }, { txt: "8", cls: "btn-info" }, { txt: "9", cls: "btn-info" }, { txt: "x", cls: "btn-warning" },
    { txt: "4", cls: "btn-info" }, { txt: "5", cls: "btn-info" }, { txt: "6", cls: "btn-info" }, { txt: "-", cls: "btn-warning" },
    { txt: "1", cls: "btn-info" }, { txt: "2", cls: "btn-info" }, { txt: "3", cls: "btn-info" }, { txt: "+", cls: "btn-warning" },
    { txt: "0", cls: "btn-info" }, { txt: ".", cls: "btn-info" }, { txt: "=", cls: "btn-success" },
  ];

  return (
    
     <div className="page-content bg-white">	
      <div className="banner-wraper">
						<div className="page-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>SIMULADOR</h1>
									<nav aria-label="breadcrumb" className="breadcrumb-row">
										<ul className="breadcrumb">
											<li className="breadcrumb-item"><Link to="/"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> INICIO</Link></li>
											<li className="breadcrumb-item active" aria-current="page">CALCULADORA SIMPLE</li>
										</ul>
									</nav>
								</div>
							</div>
							<img className="pt-img1 animate-wave" src={waveBlue} alt=""/>
							<img className="pt-img2 animate2" src={circleDots} alt=""/>
							<img className="pt-img3 animate-rotate" src={plusBlue} alt=""/>
						</div>
					</div>	
          <div className="container d-flex justify-content-center align-items-center vh-100">
      <div className="card bg-dark shadow-lg p-3" style={{ maxWidth: '350px', borderRadius: '20px' }}>
        <div className="card-body">
          {/* Pantalla */}
          <div className="text-end mb-4 p-3 bg-black rounded border border-secondary">
            <div className="text-secondary small text-truncate" style={{ minHeight: '20px' }}>
              {formula || "0"}
            </div>
            <div className="text-white h2 mb-0 text-truncate">
              {display}
            </div>
          </div>

          {/* Teclado */}
          <div className="row g-2">
            {botones.map((btn, idx) => (
              <div key={idx} className={btn.txt === "0" ? "col-6" : "col-3"}>
                <button
                  onClick={() => handleClick(btn.txt)}
                  className={`btn ${btn.cls} w-100 py-3 fs-5 fw-bold rounded-3 shadow-sm`}
                >
                  {btn.txt}
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
      </div>
      </div>
      
      
    
  );
};

export default Operaciones;